import { objToQueryString } from '@helpers'

export default Vue.extend({
  props: {
    coach: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        substitute_id: null,
        start_date: null,
        end_date: null
      },
      substitutes: [],
      unavailableDates: [],
            loadedDates: []
        }
    },
    watch: {
        'form.start_date'(date) {
            $("#end-date-input").datepicker('setStartDate', new Date(date))
        }
    },
    computed: {
        isValid() {
            return _.compact(Object.values(this.form)).length >= 3
        },
        hasSelectedDateRange() {
            return !!(this.form.start_date && this.form.end_date)
    }
  },
  methods: {
    prepareParams(date) {
      const previousMonth = date.clone().subtract(1, 'month')
      const currentMonth = date.clone()
      const nextMonth = date.clone().add(1, 'month')

      let dates = [previousMonth, currentMonth, nextMonth]

      // check if any of the dates were already fetched
      dates = dates.filter((d) => !this.loadedDates.includes(d.format('YYYY-MM')))

      // if all the dates were already fetched then return null
      if (dates.length === 0) {
        return null
      }

      // mark dates as fetched
      this.loadedDates.push(...dates.map((d) => d.format('YYYY-MM')))

      return objToQueryString({
        start_date: moment
          .min(dates)
          .startOf('month')
          .format('YYYY-MM-DD'),
        end_date: moment
          .max(dates)
          .endOf('month')
          .format('YYYY-MM-DD')
      })
    },
    fetchUnavailableDates(paramDate = null) {
      const date = moment(paramDate || moment())

      const params = this.prepareParams(date)

      // if params couldn't be build then return a empty array
      if (!params) {
        return Promise.resolve([])
      }

      return axios.get(`/coaches/${this.coach.id}/vacations/unavailable-dates?${params}`).thenData()
    },
    async fetchSubstitutes() {
      if (!this.hasSelectedDateRange) {
        return
      }

      this.substitutes = await axios.get(`/coaches/${this.coach.id}/vacations/substitutes`, { params: this.form }).thenData()

            // if already selected substitute isn't available remove it
            if (!_.find(this.substitutes, { id: this.form.substitute_id })) {
                this.form.substitute_id = this.form.substitute_id === 'no-substitute' ? 'no-substitute' : null
            }

            this.$nextTick(() => {
                $('.selectpicker').selectpicker('refresh')
            })
        }
    }
})
